
import { defineComponent, PropType, reactive } from 'vue'

// @components
import FileUploader from '@/modules/NewDispatcher/components/FileUploader/index.vue'

// @types
import { CourierDriverLicense } from '@/new-services/types/couriers'

// @services
import filesAPI from '@/new-services/files.service'

// @realisations
import { couriers } from '@/core/realisations/couriers.realisation'

// @composable
import useNotifications from '@/common/composable/useNotifications'

export default defineComponent({
    components: {
        FileUploader,
    },
    props: {
        driverLicenses: {
            type: Array as PropType<CourierDriverLicense[]>,
            default: () => [],
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        courierId: {
            type: Number,
            default: null,
        },
        isCanDelete: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['files-uploaded', 'file-deleted'],
    setup(props, { emit }) {
        const notifications = useNotifications()

        const state = reactive({
            is_loading: false,
        })

        const onUploadFiles = async (files: File[]) => {
            try {
                state.is_loading = true

                const form_data = new FormData()
                form_data.append('type', '11')

                files.forEach((file) => {
                    form_data.append('files[]', file)
                })

                await couriers.uploadDocument(props.courierId, form_data)

                emit('files-uploaded')
                notifications.notify({ type: 'success', title: 'Документы загружены' })
            } catch (error) {
                console.error(error)
                notifications.notifyError({
                    error,
                    title: 'При загрузке документов произошла ошибка',
                })
            } finally {
                state.is_loading = false
            }
        }

        const onDeleteFile = async (driver_license: CourierDriverLicense) => {
            const file_name = getFileName(driver_license)

            const answer = confirm(`Вы действительно хотите удалить документ "${file_name}" ?`)
            if (!answer) return

            try {
                await filesAPI.deleteFile(driver_license.uuidHash)

                emit('file-deleted', { ...driver_license })
                notifications.notify({ type: 'success', title: 'Документ удалён' })
            } catch (error) {
                console.error(error)
                notifications.notifyError({
                    error,
                    title: 'При удалении документа произошла ошибка',
                })
            }
        }

        const getFileName = (driver_license: CourierDriverLicense) => {
            const splitted = driver_license.url.split('/')
            const file_name = splitted[splitted.length - 1]
            return file_name
        }

        return {
            state,
            onUploadFiles,
            onDeleteFile,
            getFileName,
        }
    },
})
